import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { logoutUser } from "../../store/actions"

class Logout extends Component {

  componentDidMount = () => {
    // emit the event
    // sessionStorage.removeItem()
    // localStorage.removeItem()
    this.props.logoutUser(this.props.history)
    sessionStorage.setItem("CourseName", null)
    sessionStorage.setItem("CourseDetails", null)
  }

  render() {
    return <React.Fragment></React.Fragment>
  }
}

Logout.propTypes = {
  history: PropTypes.any,
  logoutUser: PropTypes.func
}

export default withRouter(connect(null, { logoutUser })(Logout))
